// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"276":"6e3d4e7b","306":"0b68531b","580":"aea42695","730":"fe0e12d4"}[chunkId] + ".chunk.js";
};